module.exports = __webpack_public_path__ + "img/anime.3d8af324.png";